import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import BaseLayout from '../components/BaseLayout';
import BaseLayoutCta from '../components/BaseLayoutCta/BaseLayoutCta';
import ForgotPasswordCard from '../components/ForgotPassword/ForgotPasswordCard';
import { PAGES } from '../constants/pages';

const ResetSuccessfulPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleLogin = () => {
    history.push(PAGES.LOGIN_PATH);
  };

  return (
    <BaseLayout noLogoBox>
      <ForgotPasswordCard
        title={t('resetPassword.title')}
        subtitle={t('resetPassword.resetSuccessful.description')}
      >
        <BaseLayoutCta
          buttonProps={{
            type: 'submit',
            title: t('loginFluent.login'),
            onClick: handleLogin,
          }}
          fullWidth
        />
      </ForgotPasswordCard>
    </BaseLayout>
  );
};

export default ResetSuccessfulPage;
